import * as React from 'react'

export const KnownCrawlerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={57} height={57} viewBox="0 0 57 57" fill="none">
    <path
      fill={'#FFEBF3'}
      d="M28.5 57C44.24 57 57 44.24 57 28.5S44.24 0 28.5 0 0 12.76 0 28.5 12.76 57 28.5 57Z"
    />
    <path
      stroke={'#E12468'}
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M33.41 29.5a5.32 5.32 0 1 0 0 10.64 5.32 5.32 0 0 0 0-10.64ZM41.09 42.5l-3.87-3.88"
    />
    <path
      stroke={'#E12468'}
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M24.75 37.22h-5.91a1.34 1.34 0 0 1-1.34-1.34V19.37A1.339 1.339 0 0 1 18.84 18h16.51a1.34 1.34 0 0 1 1.34 1.34v7.55M21.46 21.5h2.23M21.46 29.24h4.17M21.46 32.99h2.53M17.5 24.94h19.19"
    />
  </svg>
)
